export default __webpack_public_path__ + "static/media/32_thumbnail.13c73795.JPG";